import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type StatusFilterValue = 'all' | 'actives';

type RootAuthorisationsState = {
  mainFilters: {
    status: StatusFilterValue;
  };
};
const initialState: RootAuthorisationsState = {
  mainFilters: {
    status: 'actives',
  },
};

export const authorisationsSlice = createSlice({
  name: 'authorizations',
  initialState,
  reducers: {
    statusChanged: (state, { payload }: PayloadAction<{ status: StatusFilterValue }>) => {
      state.mainFilters.status = payload.status;
    },
  },
  selectors: {
    status: (state) => state.mainFilters.status,
  },
});

export const authorisationsSelectors = authorisationsSlice.selectors;
export const authorisationsActions = authorisationsSlice.actions;
